import React, { useEffect, useState } from 'react'
import {
  Button,
  Container,
  Row,
  Col,
  Card,
  UncontrolledTooltip,
  Form,
  FormGroup,
  CardBody,
  Label,
  Input,
  CardHeader
} from 'reactstrap'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import ReactTable from 'react-table'
import { connect } from 'react-redux'
import { compose } from 'redux'
import _ from 'lodash'

import PageTitle from 'components/Title/PageTitle'
import ArkPagination from 'components/Pagination'
import AlertNotSubscribe from 'components/Alert'
import SendersHOC from './actions'
import Create from './Create'
import Update from './Update'

import { convertSearchObjectToBase64 } from 'utils/objToBase64'
import Lang from 'Lang/General'

const SenderListing = props => {
  const [ subscribedPackage, setSubscribePackage ] = useState( true )

  useEffect( () => {
    let tmpIndex = _.findIndex( props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Marketing Funnel' })
    setSubscribePackage( tmpIndex > -1 )
    props.getAllSender( convertSearchObjectToBase64({ is_paginated: true, page: 1 }) )
  }, [])

  const handleSecurityModulesCreate = () => {
    let tmp = _.find( props.data.roleReducer.role.platforms, { name: 'Aciso Cockpit' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'Marketing Funnels' })
      return tmpModules.is_create && subscribedPackage
    }
  }

  const handleSecurityModulesUpdate = () => {
    let tmp = _.find( props.data.roleReducer.role.platforms, { name: 'Aciso Cockpit' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'Marketing Funnels' })
      return tmpModules.is_update
    }
  }

  return (
    <>
      <PageTitle
        heading={ Lang[ 'SENDER' ][ props.data.languageReducer.userSettings.admin_panel_language ] }
        icon="pe-7s-news-paper icon-gradient bg-happy-itmeo"
        buttons={[
          {
            buttonText: Lang[ 'CREATE_SENDER' ][ props.data.languageReducer.userSettings.admin_panel_language ],
            onClick: () => {
              props.onChangeSenderHOC( 'showCreateSender', true )
            },
            display: handleSecurityModulesCreate()
          }
        ]}
         />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={ true }
        transitionAppearTimeout={ 0 }
        transitionEnter={ false }
        transitionLeave={ false }>
        <Container fluid>
          {
            !subscribedPackage && (
              <AlertNotSubscribe { ...props } />
            )
          }
          <Row>
            <Col md={ 12 }>
              <Card className="main-card mb-3">
                <CardHeader>{ Lang[ 'SEARCH' ][ props.data.languageReducer.userSettings.admin_panel_language ] }</CardHeader>
                <CardBody>
                  <Form onSubmit={ e => e.preventDefault()}>
                    <FormGroup>
                      <Label>{ Lang[ 'EMAIL' ][ props.data.languageReducer.userSettings.admin_panel_language ] }</Label>
                      <Input
                        type={ 'text' }
                        value={ props.senderSearchParams[0].param }
                        onChange={ e => {
                          let tmp = _.cloneDeep( props.senderSearchParams )
                          tmp[ 0 ][ 'param' ] = e.target.value
                          return props.onChangeSenderHOC( 'senderSearchParams', tmp )
                        }} />
                    </FormGroup>
                    <div className="d-flex">
                      <Button
                        color="primary"
                        style={{ marginLeft: 'auto' }}
                        onClick={() => {
                          let tmp = {
                            is_paginated: true,
                            page: 1,
                            filter: {
                              email: {
                                $like: `%${props.senderSearchParams[0].param}%`
                              }
                            }
                          }
                          props.getAllSender( convertSearchObjectToBase64( tmp ) )
                        }}>{ Lang[ 'SEARCH' ][ props.data.languageReducer.userSettings.admin_panel_language ] }</Button>
                      <Button
                        color="danger"
                        style={{ marginLeft: '10px' }}
                        onClick={() => {
                          let tmp = [
                            {
                              label: 'Email',
                              value: 'email',
                              param: ''
                            }
                          ]
                          props.onChangeSenderHOC( 'senderSearchParams', tmp )
                          props.getAllSender( convertSearchObjectToBase64({ page: 1, is_paginated: true }) )
                        }}>{ Lang[ 'RESET' ][ props.data.languageReducer.userSettings.admin_panel_language ] }</Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
            <Col md={ 12 }>
              <Card className="main-card mb-3 p-4">
                <ReactTable
                  NoDataComponent={ () => <span></span> }
                  data={ props.senders.data }
                  columns={[
                    {
                      Header: Lang[ 'EMAIL' ][ props.data.languageReducer.userSettings.admin_panel_language ],
                      accessor: 'email'
                    },
                    {
                      Header: Lang[ 'NAME' ][ props.data.languageReducer.userSettings.admin_panel_language ],
                      accessor: 'name'
                    },
                    {
                      Header: Lang[ 'ACTIONS' ][ props.data.languageReducer.userSettings.admin_panel_language ],
                      accessor: "id",
                      Cell: ({row}) => (
                        handleSecurityModulesUpdate() ? (
                          <>
                            <Button
                              id={ `sender-${ row.id }-update` }
                              className="mb-2 mr-2 btn-icon btn-icon-only"
                              color="primary"
                              onClick={ () => {
                                props.getSelectedSender( row.id )
                                props.onChangeSenderHOC( 'showUpdateSender', true )
                              } }
                              disabled={ !subscribedPackage }>
                              <i className="pe-7s-pen"> </i>
                            </Button>
                            <UncontrolledTooltip
                              target={ `sender-${ row.id }-update` }
                              placement="top">
                              { Lang[ 'EDIT_SENDER' ][ props.data.languageReducer.userSettings.admin_panel_language ] }
                            </UncontrolledTooltip>
                          </>
                        ) : (
                          <></>
                        )
                      )
                    }
                  ]}
                  showPagination={ false }
                  defaultPageSize={ 10 } />
                  {
                    props.senders.data && props.senders.data.length > 0 && (
                      <ArkPagination
                        meta={ props.senders.meta }
                        onChangePage={ page => {
                          let tmp = {
                            page: page,
                            is_paginated: true
                          }
                          let tmpFilter = {}

                          props.senderSearchParams.map( searchItem => {
                            if( !_.isEmpty( searchItem.param ) && searchItem.value !== 'recipient_groups' ){
                              tmpFilter = {
                                ...tmpFilter,
                                [searchItem.value]: searchItem.value === 'title' ? { $like: `%${ searchItem.param }%` } : searchItem.param
                              }
                            }
                          })

                          let tmpString = convertSearchObjectToBase64( !_.isEmpty( tmpFilter ) ? { ...tmp, filter: tmpFilter } : tmp )
                          props.getAllSender( tmpString )
                        }} />
                    )
                  }
              </Card>
            </Col>
          </Row>
        </Container>
        <Create{...props} />
        <Update {...props} />
      </ReactCSSTransitionGroup>
    </>
  )
}

const mapStateToProps = state => ({ data: state })

export default compose(
  SendersHOC,
  connect( mapStateToProps ),
)( SenderListing )
